import AccountConfirmationContainer from './AccountConfirmationContainer';

export default AccountConfirmationContainer;
